import React from "react";
import injectSheet from 'react-jss';
import styles from './expandablelisttable_styles';


const ExpandableListTable = (props) => {
    const {
        columnHeads,
        data,
        classes,
        expandableKlass,
        tableClass,
        tableBodyClass,
        tableHeaderClass,
    } = props;


    return (
        <div className={`${classes.table} ${tableClass}`}>
            <div className={`${classes.tablehead} ${tableHeaderClass}`}>
                {columnHeads.map(col => <div
                    className={`${classes.column} column-tablehead column-${col.key}`}>{col.title}
                </div>)}
            </div>
            <div className={`${classes.table} ${tableBodyClass}`}>
                {data.map((row, i) => {
                    return (
                        <>
                            <div className={`${classes.tablerow} ${(i % 2 === 0) ? classes.oddrow : null}`}>
                                {Object.entries(row).map(([key, val]) => key !== 'expandable' && <div
                                    className={`${classes.column} column-tablerow column-${key}`}>{val}</div>)}
                            </div>
                            <div className={`${classes.expandable} ${(i % 2 === 0) ? classes.oddrow : null} ${expandableKlass}`}>
                                {row.expandable}
                            </div>
                        </>
                    )
                })}
            </div>
        </div>
    )

}

export default injectSheet(styles)(ExpandableListTable)